(function () {
  // Mobile menu
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-menu-btn]');
    var nav = document.getElementById('mobile-nav');
    if (btn && nav) {
      var open = nav.hidden;
      nav.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    } else if (nav && !nav.hidden && e.target.closest('#mobile-nav a')) {
      nav.hidden = true;
      var b = document.querySelector('[data-menu-btn]');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-label', 'Open menu'); }
    }
  });

  // Marquee: repeat the set to fill the screen, then duplicate once so the -50% loop is seamless.
  function initMarquee(root) {
    var track = root.querySelector('[data-track]');
    var set = root.querySelector('[data-set]');
    if (!track || !set || root.classList.contains('is-animated')) return;
    var items = Array.prototype.slice.call(set.children).filter(function (el) { return el.classList.contains('card'); });
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var copies = Math.max(1, Math.ceil(window.innerWidth / set.offsetWidth));
    for (var i = 1; i < copies; i++) items.forEach(function (el) { set.appendChild(el.cloneNode(true)); });
    var dup = set.cloneNode(true);
    dup.removeAttribute('data-set');
    track.appendChild(dup);
    root.classList.add('is-animated');
    // Clones are decorative: hide from assistive tech and the tab order.
    Array.prototype.slice.call(set.children).slice(items.length).concat([dup]).forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
      el.querySelectorAll('a,button').forEach(function (n) { n.tabIndex = -1; });
    });
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-marquee]').forEach(initMarquee); }

  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
